<template>
  <v-menu :close-on-content-click="false" bottom absolute>
    <template v-slot:activator="{on}" >
      <v-btn icon  v-on="on" dark>
        <v-icon>settings_suggest</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-text>


        <v-text-field
            outlined
            label="Tiempo de preparación"
            v-model="preparationTime"
            type="number"
        >
          <template v-slot:append>
            Min
          </template>
        </v-text-field>

        <v-text-field
            outlined
            label="Tiempo de delivery"
            v-model="deliveryTime"
            type="number"
        >
          <template v-slot:append>
            Min
          </template>
        </v-text-field>

        <v-text-field
            outlined
            label="Tiempo de delivery larga distancia"
            v-model="deliveryTimeLongDistance"
            type="number"
        >
          <template v-slot:append>
            Min
          </template>
        </v-text-field>

        <v-text-field
            outlined
            label="Kilómetros Corta Distancia"
            v-model="maxKmForMinCost"
            type="number"
        >
          <template v-slot:append>
            Km
          </template>
        </v-text-field>

        <v-text-field
            outlined
            label="Máxima distancia en KM para delivery"
            v-model="maxKmForDelivery"
            type="number"
        >
          <template v-slot:append>
            Km
          </template>
        </v-text-field>

      </v-card-text>

    </v-card>

  </v-menu>

</template>

<script>

import {SettingsProvider} from "@dracul/settings-frontend"

export default {
  name: "SettingExpress",
  computed: {
    deliveryTime: {
      get() {
        return this.$store.getters.getSettingValue('DeliveryTime')
      },
      set(value) {
        const KEY = 'DeliveryTime'
        SettingsProvider.settingValueUpdateByKey(KEY,value)
      }
    },
    deliveryTimeLongDistance: {
      get() {
        return this.$store.getters.getSettingValue('DeliveryTimeLongDistance')
      },
      set(value) {
        const KEY = 'DeliveryTimeLongDistance'
        SettingsProvider.settingValueUpdateByKey(KEY,value)
      }
    },
    preparationTime: {
      get() {
        return this.$store.getters.getSettingValue('PreparationTime')
      },
      set(value) {
        const KEY = 'PreparationTime'
        SettingsProvider.settingValueUpdateByKey(KEY,value)
      }
    },
    maxKmForMinCost: {
      get() {
        return this.$store.getters.getSettingValue('maxKmForMinCost')
      },
      set(value) {
        const KEY = 'maxKmForMinCost'
        SettingsProvider.settingValueUpdateByKey(KEY,value)
      }
    },
    maxKmForDelivery: {
      get() {
        return this.$store.getters.getSettingValue('maxKmForDelivery')
      },
      set(value) {
        const KEY = 'maxKmForDelivery'
        SettingsProvider.settingValueUpdateByKey(KEY,value)
      }
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
